import { render, staticRenderFns } from "./PlansAndBillingScreen.vue?vue&type=template&id=149f85d3&"
import script from "./PlansAndBillingScreen.vue?vue&type=script&lang=js&"
export * from "./PlansAndBillingScreen.vue?vue&type=script&lang=js&"
import style0 from "./PlansAndBillingScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports